export const ActionTypes = {
  LOADING: "UPDATE_CONS_LOADING",
  ERROR: "UPDATE_CONS_ERROR",
  SUCCESS: "UPDATE_CONS_SUCCESS",
};
